
export function registerTabManager(tabRouter) {
  console.log(tabRouter);
}
